module.exports = __webpack_public_path__ + "static/media/wn_22.1090fb1d.jpg";